import { createRoot } from "react-dom/client";
import AcpValidator from "@packages/home/app/frontend/components/tools/AcpValidator";
const root = document.getElementById("acp-validator-root");
const context = document.getElementById("acp-validator-context");
if (root && context) createRoot(root).render(<AcpValidator {...JSON.parse(context.textContent ?? "{}")} />);
